var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLegalPerson = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31.0455L14 25.6885H22L20 31.0455H16Z",
    fill: "#F98979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92893 26.7667C4.80429 24.9027 7.34783 23.8555 10 23.8555H26C28.6522 23.8555 31.1957 24.9027 33.0711 26.7667C34.9464 28.6308 36 31.159 36 33.7952V37.7711C36 38.869 35.1046 39.759 34 39.759C32.8954 39.759 32 38.869 32 37.7711V33.7952C32 32.2135 31.3679 30.6966 30.2426 29.5781C29.1174 28.4597 27.5913 27.8314 26 27.8314H10C8.4087 27.8314 6.88258 28.4597 5.75736 29.5781C4.63214 30.6966 4 32.2135 4 33.7952V37.7711C4 38.869 3.10457 39.759 2 39.759C0.89543 39.759 0 38.869 0 37.7711V33.7952C0 31.159 1.05357 28.6308 2.92893 26.7667Z",
    fill: "#F98979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.97592C14.6863 3.97592 12 6.64604 12 9.9398C12 13.2336 14.6863 15.9037 18 15.9037C21.3137 15.9037 24 13.2336 24 9.9398C24 6.64604 21.3137 3.97592 18 3.97592ZM8 9.9398C8 4.4502 12.4772 0 18 0C23.5228 0 28 4.4502 28 9.9398C28 15.4294 23.5228 19.8796 18 19.8796C12.4772 19.8796 8 15.4294 8 9.9398Z",
    fill: "#F98979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 38.1881L16 31.0454L18 29.2598L20 31.0454L24 38.1881H12Z",
    fill: "#F98979"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLegalPerson, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/legal-person.0b086f45.svg";
export { ForwardRef as ReactComponent };